import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import WarningIcon from '@material-ui/icons/Warning';
import classNames from 'classnames';
import { default as MaterialSnackbarContent } from '@material-ui/core/SnackbarContent';
import { IconButton } from '@material-ui/core';
import PropTypes from 'prop-types';
var variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon
};

var styles = function styles(theme) {
  return {
    icon: {
      marginRight: '8px'
    },
    snackbar: {
      boxShadow: 'none'
    },
    squaredSnackbar: {
      boxShadow: 'none',
      borderRadius: 0
    },
    compact: {
      minWidth: '0px'
    },
    info: {
      border: '1px solid #57637C',
      backgroundColor: '#FBFCFD',
      color: '#333940'
    },
    error: {
      backgroundColor: '#D21310'
    },
    warning: {
      backgroundColor: '#FF8200'
    },
    success: {
      backgroundColor: '#E3F4E8',
      border: '1px solid #048829',
      color: '#03661E'
    },
    message: {
      display: 'flex',
      alignItems: 'center'
    },
    flex: {
      flex: 1
    }
  };
};

var SnackbarContent =
/*#__PURE__*/
function (_Component) {
  _inherits(SnackbarContent, _Component);

  function SnackbarContent() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, SnackbarContent);

    var _temp;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SnackbarContent)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.onClose = function () {
      var onClose = _this.props.onClose;
      if (onClose) onClose();
    }, _temp));
  }

  _createClass(SnackbarContent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          timeout = _this$props.timeout,
          onClose = _this$props.onClose;
      onClose && timeout && setTimeout(function () {
        return onClose();
      }, timeout);
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          classes = _props.classes,
          variant = _props.variant,
          message = _props.message,
          onClose = _props.onClose,
          squared = _props.squared,
          compact = _props.compact,
          other = _objectWithoutProperties(_props, ['classes', 'variant', 'message', 'onClose', 'squared', 'compact']);

      variant = variant || 'info';
      var Icon = variantIcon[variant];
      return React.createElement(MaterialSnackbarContent, _extends({}, other, {
        className: classNames(squared ? classes.squaredSnackbar : classes.snackbar, classes[variant], compact === true ? classes.compact : undefined),
        classes: {
          message: classes.flex
        },
        message: React.createElement('span', {
          className: classes.message
        }, compact !== true && React.createElement(Icon, {
          className: classes.icon
        }), message || 'no message provided'),
        action: onClose !== undefined && [React.createElement(IconButton, {
          key: 'close',
          'aria-label': 'Close',
          color: 'inherit',
          onClick: this.onClose
        }, React.createElement(CloseIcon, null))]
      }));
    }
  }]);

  return SnackbarContent;
}(Component);

SnackbarContent.propTypes = _extends({}, MaterialSnackbarContent.propTypes, {
  onClose: PropTypes.func,
  timeout: PropTypes.number
});
export default withStyles(styles)(SnackbarContent);